import React, { useState, useEffect, useContext, useRef, Ref } from "react";
import { useQuery } from "react-query";
import { Card, Button, Text, Flex, Box } from "rebass";
import { CardHeader, Selector, SliderInput } from "../../../../Components";
import { Patient } from "../../../../Types";
import { Checkbox, Label, Select } from "@rebass/forms";
import { Form, Formik } from "formik";
import axios from "axios";
import { VVPLayout, VVPLayoutsAPIResponse } from "../../../../Types";
import { AuthContext, MessageType } from "../../../../Contexts";
import { MessageContext } from "../../../../Contexts";
import {
  CardFooter,
  Modal,
  DateInput,
  RadioInput,
  SelectInput,
  CheckBoxInput,
  StyledInputBox,
} from "../../../../Components";
import { HardwareConfig } from "./HardwareConfig";
import { ManageHeadsetModal } from "../../../ManageHeadsetsModal";
import { NONAME } from "dns";
import { useVVPLayouts } from "../../../../Hooks/getLayouts";
import { useVVPTestConfig } from "../../../../Hooks/getTestConfig";
import { useSetVVPTestConfig } from "../../../../Hooks/setTestConfig";
import _, { filter } from "lodash";

export const ConfigurationContainer: React.FC<{
  patient: Patient;
}> = ({ patient }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [addGameModalOpen, setAddGameModalOpen] = useState(false);
  const [gameSettingData, setGameSettingData] = useState<any>(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selected_headset_name, setSelectedHeadsetName] = useState<string>("");

  const authContext = useContext(AuthContext);
  const messageContext = useContext(MessageContext);

  const [headsets, setHeadsets] = useState<any>({});
  const headset_selections = Object.keys(headsets).map(
    (key) => key + " - " + headsets[key]
  );
  const fetchHeadsets = async (patientID: string) => {
    setHeadsets({
      "headset 1": "No License",
      "headset 2": "Single Patient",
      "headset 3": "Multi Patient",
    });
  };

  type Layouts = {
    Screen?: Layout[];
    Monitor?: Layout[];
    Other?: Layout[];
    Fetched: boolean;
  };

  type Layout = {
    name: string;
    display_name: string;
    metadata: string;
    summary: string;
    preview_image: string;
  };

  // const [layoutLists, setLayoutLists] = useState<Layouts>({Screen: [], Monitor: [], Other:[], Fetched: false});
  // const [layoutList, setLayoutList] = useState<Layout[]>([]);
  const [patientTestConfig, setPatientTestConfig] = useState<string[]>([]);

  // const layoutTypes = ["Screen", "Monitor", "Other"];
  let selectedLayoutTypeIndex = 0;
  const [selectedLayoutIndex, setSelectedLayoutIndex] = useState(0);

  const { data: layoutsData, isLoading: layoutsLoading } = useVVPLayouts({});
  // console.log("layoutsData",layoutsData);

  const { data: testConfigData, isLoading: testConfigLoading } =
    useVVPTestConfig({
      clinic_user_id: patient.clinic_user_id,
    });

  const setTestConfigMutation = useSetVVPTestConfig();

  const [saveButtonDisabledState, setSaveButtonDisabledState] =
    useState<boolean>(true);
  // const [revertButtonDisabledState, setRevertButtonDisabledState] = useState<boolean>(true);

  type VVPTestConfig = {
    AudioMode: string;
    ControlMode: string;
    FixationAssist: boolean;
    Layout: string | null;
    LayoutType: string;
    TestDurationLimitSec: number;
    TestEyes: string;
    TutorialEnabled: boolean;
  };

  const defaultTestConfig: VVPTestConfig = {
    AudioMode: "On",
    ControlMode: "Hand",
    FixationAssist: true,
    Layout: "24-2-S",
    LayoutType: "Screen",
    TestDurationLimitSec: 3600,
    TestEyes: "Right",
    TutorialEnabled: true,
  };

  const Lateralities = ["Bilateral", "Left", "Right"];
  const ControlModes = ["Head", "Hand"];

  const [serverTestConfig, setServerTestConfig] = useState(defaultTestConfig);
  const [hasServerSettings, setHasServerSettings] = useState(false);
  const [config, setConfig] = useState<VVPTestConfig>(defaultTestConfig);

  useEffect(() => {
    setConfig(defaultTestConfig);
  }, []);

  useEffect(() => {
    console.log("effect config", config);
    console.log("serverTestConfig", serverTestConfig);

    if (
      (!_.isEqual(config, serverTestConfig) && config.Layout) ||
      !hasServerSettings
    )
      setSaveButtonDisabledState(false);
    else setSaveButtonDisabledState(true);

    console.log("saveButtonDisabledState", saveButtonDisabledState);
  }, [config, serverTestConfig]);

  useEffect(() => {
    console.log("effect::testConfigData", testConfigData);
    if (testConfigData?.test_config) {
      setServerTestConfig(testConfigData.test_config);
      setHasServerSettings(testConfigData.has_vvp_settings);
      setConfig(testConfigData.test_config);
      console.log("effect::config", config);
    }
  }, [testConfigData]);

  const HardwareReference = useRef(null);
  const TestReference = useRef(null);

  const uploadHardwareConfiguration = async () => {
    // @ts-ignore
    axios
      .post("/vue_api/set_hardware_config", {
        clinic_user_id: patient.clinic_user_id,
        // @ts-ignore
        hardware_config: HardwareReference.current?.values,
      })
      .then((response) => {
        console.log("Upload response: ", response);
      });
  };

  const [testConfigStatus, setTestConfigStatus] = useState("");

  const uploadTestConfiguration = async () => {
    // @ts-ignore
    console.log("Uploading Test Config: ", TestReference.current.values);
    // @ts-ignore
    axios
      .post("/vue_api/set_test_config", {
        clinic_user_id: patient.clinic_user_id,
        // @ts-ignore
        test_config: TestReference.current?.values,
      })
      .then((response) => {
        console.log("Upload response: ", response);
        if (response.data.success) {
          setServerTestConfig(response.data.test_config);
          setHasServerSettings(true);
        }
        let msg = response.data.success
          ? response.data.success
          : response.data.error;
        setTestConfigStatus(msg);
        messageContext.addMessage(msg, MessageType.success);
      });
  };

  // const {isLoading: isLoadingLayouts, error: isErrorLayouts, data: dataLayouts} = useQuery("layouts", useLayouts);
  // const {isLoading: isLoadingTestConfig, error: isErrorTestConfig, data: dataTestConfig} = useQuery(["testConfig", patient.clinic_user_id], useTestConfig,{cacheTime: 0});

  // console.log('isLoadingTestConfig', isLoadingTestConfig);

  console.log(
    "Lateralities.indexOf(config.TestEyes)",
    Lateralities.indexOf(config.TestEyes)
  );

  if (layoutsLoading || testConfigLoading) return null;

  // @ts-ignore
  //console.log("find", headset_selections.findIndex(value => value === "headset 1 - No License"))

  // Return the body of the configuration container. Including both the hardware and the test forms.
  return (
    <>
      <ManageHeadsetModal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        selected_headset_name={selected_headset_name}
      />
      {/*
            <ConfigurationForm
                configuration_type="hardware"
                uploadToHeadset={() => uploadHardwareConfiguration()}
                clinic_user_id={patient.clinic_user_id}
                form_reference={HardwareReference}
                inputs={
                    <>
                        <Flex alignItems="center">

                            <SelectInput label="Headset" name="headset" options={headset_selections}/>

                            <Button onClick={() => {
                                // @ts-ignore
                                const selected_index = headset_selections.findIndex(value => value === HardwareReference.current.values.headset);
                                setSelectedHeadsetName(Object.keys(headsets)[selected_index]);
                                setModalIsOpen(true);
                            }}>
                                Manage
                            </Button>
                        </Flex>

                        <RadioInput label="Layout Type" name="layout_type" options={layoutTypes} onStateChange={onLayoutTypeChange}/>
                        <SelectInput label="Layout" name="layout" options={layoutList} selectedIndex={0}/>
                    </>
                }
            /> */}
      <ConfigurationForm
        configuration_type="test"
        uploadToHeadset={() => uploadTestConfiguration()}
        clinic_user_id={patient.clinic_user_id}
        form_reference={TestReference}
        testConfigStatus={testConfigStatus}
        saveButtonDisabledState={saveButtonDisabledState}
        inputs={
          <>
            <CheckBoxInput
              helperParameters={{ label: "Give Tutorial" }}
              name="TutorialEnabled"
              onChange={(selection: boolean) => {
                if (config.TutorialEnabled !== selection)
                  setConfig({ ...config, TutorialEnabled: selection });
              }}
              value={
                config.TutorialEnabled !== null ? config.TutorialEnabled : false
              }
            />
            {layoutsData && (
              <RadioInput
                helperParameters={{ label: "Layout Type" }}
                name="LayoutType"
                options={layoutsData.types}
                onStateChange={(selection: any) =>
                  setConfig({
                    ...config,
                    LayoutType: layoutsData.types[selection],
                    Layout:
                      layoutsData?.layouts.filter(
                        (l) =>
                          l.type === config.LayoutType &&
                          l.name === config.Layout
                      ) !== []
                        ? config.Layout
                        : null,
                  })
                }
                selectedIndex={layoutsData.types.indexOf(config.LayoutType)}
              />
            )}
            <SelectInput
              helperParameters={{
                label: "Layout",
                loading: !layoutsData?.layouts,
              }}
              name="Layout"
              options={
                layoutsData?.layouts
                  .filter((l) => l.type === config.LayoutType)
                  .map((l) => l.name) || []
              }
              onChange={(selection: any) => {
                setConfig({ ...config, Layout: selection });
                console.log("Layout selection", selection);
              }}
              selectedIndex={layoutsData?.layouts
                .filter((l) => l.type === config.LayoutType)
                .findIndex((l) => l.name === config.Layout)}
            />
            {
              //layoutLists.Fetched  ?  <img src={"/" + layoutList[selectedLayoutIndex].preview_image} alt={layoutList[selectedLayoutIndex].name} /> : ""
            }
            <RadioInput
              helperParameters={{ label: "Laterality" }}
              name="TestEyes"
              labels={["Test Both Eyes", "Left Only", "Right Only"]}
              options={Lateralities}
              onStateChange={(selection: any) => {
                if (config.TestEyes !== Lateralities[selection])
                  setConfig({ ...config, TestEyes: Lateralities[selection] });
              }}
              selectedIndex={Lateralities.indexOf(config.TestEyes)}
            />
            <SliderInput
              helperParameters={{ label: "Test Timeout Limit" }}
              name="TestDurationLimitSec"
              min={600}
              max={3600}
              step={30}
              decimalPlaces={0}
              unit={"min"}
              value={config.TestDurationLimitSec}
              onChange={(value: number) => {
                if (config.TestDurationLimitSec !== value)
                  setConfig({ ...config, TestDurationLimitSec: value });
              }}
            />
            <RadioInput
              helperParameters={{ label: "Control Mode" }}
              name="ControlMode"
              options={ControlModes}
              onStateChange={(selection: any) => {
                if (config.ControlMode !== ControlModes[selection])
                  setConfig({
                    ...config,
                    ControlMode: ControlModes[selection],
                  });
              }}
              selectedIndex={
                ControlModes.includes(config.ControlMode)
                  ? ControlModes.indexOf(config.ControlMode)
                  : -1
              }
            />
            <CheckBoxInput
              helperParameters={{ label: "Fixation Task Assist" }}
              name="FixationAssist"
              onChange={(selection: boolean) => {
                if (config.FixationAssist !== selection)
                  setConfig({ ...config, FixationAssist: selection });
              }}
              value={
                config.FixationAssist !== null ? config.FixationAssist : false
              }
            />
            {/* <RadioInput helperParameters={{label: "Audio Mode"}} name="AudioMode" options={["Off", "On"]} style={{display: 'none'}} /> */}
          </>
        }
      />
    </>
  );
};

// Generates the textbox and selector used to create and select configurations
const ConfigurationForm: React.FC<{
  configuration_type: "hardware" | "test";
  uploadToHeadset: Function;
  inputs: JSX.Element;
  clinic_user_id: string;
  form_reference: any;
  testConfigStatus: string;
  saveButtonDisabledState: boolean;
}> = ({
  configuration_type,
  uploadToHeadset,
  inputs,
  clinic_user_id,
  form_reference,
  testConfigStatus,
  saveButtonDisabledState,
}) => {
  const [config_names, setConfigNames] = useState<any>(
    Object.keys(loadConfigurations()[configuration_type])
  );
  const [selected_config_name, setSelectedConfigName] = useState<any>(
    loadPatientConfigurationName(configuration_type, clinic_user_id)
  );
  const [textbox_content, setTextboxContent] =
    useState<string>(selected_config_name);

  const init_values =
    loadPatientEdit(configuration_type, clinic_user_id) ||
    loadConfigurations()[configuration_type][
      loadPatientConfigurationName(configuration_type, clinic_user_id)
    ];

  const saveTextbox = () => {
    let new_config_name = textbox_content.replaceAll("*", "");
    if (new_config_name === "default") {
      new_config_name = "custom";
      setTextboxContent(new_config_name);
    }

    // add option if it's missing
    if (!config_names.includes(new_config_name)) {
      console.log("adding new config name");
      config_names.push(new_config_name);
      setConfigNames(config_names);
    }

    setSelectedConfigName(new_config_name);

    savePatientConfigurationName(
      new_config_name,
      configuration_type,
      clinic_user_id
    );
    // @ts-ignore
    saveConfiguration(
      form_reference.current.values,
      new_config_name,
      configuration_type
    );
    dismissEdits();
  };

  const alertEdits = () => {
    if (
      loadPatientEdit(configuration_type, clinic_user_id) !== undefined &&
      textbox_content[textbox_content.length - 1] !== "*"
    ) {
      setTextboxContent(textbox_content + "*");
    }
  };

  const dismissEdits = () => {
    savePatientEdit(undefined, configuration_type, clinic_user_id);
    setTextboxContent(textbox_content.replaceAll("*", ""));
  };

  // add asterisk on first render
  // useEffect(()=>{
  //   alertEdits()
  // }, [])

  const configuration_header = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <div
        style={{ display: "none", position: "relative", paddingRight: "50px" }}
      >
        {/* Save button */}
        <img
          className="svg_button"
          src="/ui/save.svg"
          alt="save icon"
          style={{
            position: "absolute",
            left: -34,
            top: 1,
            width: "28px",
            zIndex: 10,
          }}
          onClick={(e) => saveTextbox()}
        />
        {/* New config name */}
        <StyledInputBox
          width={130}
          value={textbox_content}
          onChange={(e) => {
            setTextboxContent(e.target.value.replaceAll("*", ""));
          }}
          onFocus={(e) => {
            setTextboxContent(textbox_content.replaceAll("*", ""));
          }}
          onBlur={(e) => {
            alertEdits();
          }}
        />
      </div>
      <div
        style={{
          display: "none",
          paddingRight: "20px",
          minWidth: "200px",
          height: "35px",
          overflow: "visible",
          position: "relative",
        }}
      >
        <img
          className="svg_button"
          src="/ui/delete.svg"
          alt="delete"
          style={{
            position: "absolute",
            left: -30,
            top: 3,
            width: "28px",
            zIndex: 10,
          }}
          onClick={(e) => {
            if (
              selected_config_name === "default" ||
              selected_config_name === "default*"
            )
              return;
            dismissEdits();

            delete_configuration(selected_config_name, configuration_type);

            // Remove the deleted config's option
            for (let i = 0; i < config_names.length; i++) {
              if (config_names[i] === selected_config_name) {
                config_names.splice(i, 1);
                setConfigNames(config_names);
              }
            }

            // Update the textbox and selector with the user's new config_name
            const new_config_name = loadPatientConfigurationName(
              configuration_type,
              clinic_user_id
            );
            setSelectedConfigName(new_config_name);
            setTextboxContent(new_config_name);
          }}
        />
        {/* Config selector */}
        <Selector
          options={config_names}
          defaultIndex={config_names.indexOf(selected_config_name)}
          onChange={(config_name) => {
            dismissEdits();

            savePatientConfigurationName(
              config_name,
              configuration_type,
              clinic_user_id
            );
            setSelectedConfigName(config_name);
            setTextboxContent(config_name);
            // @ts-ignore
            // form_reference.current.setValues(loadConfigurations()[configuration_type][config_name])
          }}
        ></Selector>
      </div>

      {/* Upload to headset button */}
      <Button
        onClick={() => uploadToHeadset()}
        disabled={saveButtonDisabledState}
      >
        Update Test Configuration
      </Button>
    </div>
  );

  return (
    <Card>
      <CardHeader
        headerText={
          { hardware: "Hardware Configuration", test: "Test Configuration" }[
            configuration_type
          ]
        }
        right={<div>{configuration_header}</div>}
      />
      <Formik
        initialValues={init_values}
        onSubmit={() => {}}
        innerRef={form_reference}
      >
        <Form
          onChange={(e) => {
            // @ts-ignore
            // const values = form_reference.current.values
            // // @ts-ignore
            // values[e.target.name] = e.target.value
            // savePatientEdit(values, configuration_type, clinic_user_id)
            // alertEdits()
          }}
        >
          {inputs}
        </Form>
      </Formik>
    </Card>
  );
};

// TODO add API endpoints to tie configurations to the doctor's account.

// Loads all the configurations from local storage.
// the "default" configuration can't be overwritten by the user
const loadConfigurations = () => {
  // {config_type: {config_name: {field_name: value}}}
  let configs = JSON.parse(localStorage.getItem("configurations") || "{}");

  if (configs["hardware"] === undefined) configs["hardware"] = {};
  if (configs["test"] === undefined) configs["test"] = {};

  if (configs["hardware"]["default"] === undefined)
    configs["hardware"]["default"] = {
      headset: "headset 1 - Multi Patient",
      layoutType: "Screen",
      layout_type: "Monitor",
    };

  if (configs["test"]["default"] === undefined)
    configs["test"]["default"] = {
      AudioMode: "On",
      ControlMode: "Hand",
      FixationAssist: false,
      TutorialEnabled: true,
      TestEyes: "Test Both Eyes",
      TestDurationLimitSec: "1800",
      LayoutType: "Screen",
      Layout: "24-2-S",
    };

  return configs;
};

// Update and existing configuration or save a new one
const saveConfiguration = (
  values,
  configuration_name,
  configuration_type: "hardware" | "test"
) => {
  const configs = loadConfigurations();

  configs[configuration_type][configuration_name] = values;

  localStorage.setItem("configurations", JSON.stringify(configs));
};

const loadPatientEdit = (
  configuration_type: "hardware" | "test",
  clinic_user_id
) => {
  let patient_edits = JSON.parse(localStorage.getItem("patient_edits") || "{}");

  patient_edits[clinic_user_id] = patient_edits[clinic_user_id] || {};

  return patient_edits[clinic_user_id][configuration_type];
};

const savePatientEdit = (
  values,
  configuration_type: "hardware" | "test",
  clinic_user_id
) => {
  let patient_edits = JSON.parse(localStorage.getItem("patient_edits") || "{}");

  patient_edits[clinic_user_id] = patient_edits[clinic_user_id] || {};

  patient_edits[clinic_user_id][configuration_type] = values;

  localStorage.setItem("patient_edits", JSON.stringify(patient_edits));
};

// Load the name of the current patient's last used configuration.
const loadPatientConfigurationName = (
  configuration_type: "hardware" | "test",
  clinic_user_id
) => {
  // {clinic_user_id: {config_type: config_name}}
  let patient_configs = JSON.parse(
    localStorage.getItem("patient_configurations") || "{}"
  );

  patient_configs[clinic_user_id] = patient_configs[clinic_user_id] || {};

  patient_configs[configuration_type + "_last_used"] =
    patient_configs[configuration_type + "_last_used"] || "default";

  patient_configs[clinic_user_id][configuration_type] =
    patient_configs[clinic_user_id][configuration_type] ||
    patient_configs[configuration_type + "_last_used"];

  return patient_configs[clinic_user_id][configuration_type];
};

// update the name of the current patient's last used configuration.
const savePatientConfigurationName = (
  configuration_name,
  configuration_type: "hardware" | "test",
  clinic_user_id
) => {
  let patient_configs = JSON.parse(
    localStorage.getItem("patient_configurations") || "{}"
  );
  patient_configs[clinic_user_id] = patient_configs[clinic_user_id] || {};
  patient_configs[clinic_user_id][configuration_type] = configuration_name;
  patient_configs[configuration_type + "_last_used"] = configuration_name;

  console.log("save", configuration_name, configuration_type, patient_configs);

  localStorage.setItem(
    "patient_configurations",
    JSON.stringify(patient_configs)
  );
};

// Delete a configuration
const delete_configuration = (
  configuration_name,
  configuration_type: "hardware" | "test"
) => {
  // delete configuration values
  const configs = loadConfigurations();
  delete configs[configuration_type][configuration_name];
  localStorage.setItem("configurations", JSON.stringify(configs));

  let patient_configs = JSON.parse(
    localStorage.getItem("patient_configurations") || "{}"
  );
  // reset last used configuration name
  if (
    patient_configs[configuration_type + "_last_used"] === configuration_name
  ) {
    patient_configs[configuration_type + "_last_used"] = "default";
  }

  // reset patient configuration names
  for (let clinic_user_id in patient_configs) {
    if (
      patient_configs[clinic_user_id][configuration_type] === configuration_name
    ) {
      console.log(
        "resetting",
        patient_configs[clinic_user_id][configuration_type],
        "to",
        patient_configs[configuration_type + "_last_used"]
      );
      patient_configs[clinic_user_id][configuration_type] =
        patient_configs[configuration_type + "_last_used"];
    }
  }
  localStorage.setItem(
    "patient_configurations",
    JSON.stringify(patient_configs)
  );
};
